/* rastreio.js — /pages/acompanhe-seu-pedido
 * Sem localStorage. Listener delegado no container estável.
 * Textos aprovados pelo Brenno (não alterar sem novo aprovado).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-rastreio]');
  if (!root) return;

  var endpoint = (root.getAttribute('data-endpoint') || '').trim();
  var sacEmail = (root.getAttribute('data-sac') || 'sac@semcostura.com').trim();

  var TIMELINE = [
    { key: 'pedido',    label: 'Pedido feito' },
    { key: 'pagamento', label: 'Pagamento aprovado' },
    { key: 'postado',   label: 'Postado' },
    { key: 'transito',  label: 'Em trânsito' },
    { key: 'entregue',  label: 'Entregue' }
  ];

  // Cada mapping: até qual degrau está DONE, e qual está CURRENT.
  // -1 = não aplicável.
  var STAGE_MAP = {
    aguardando_pagamento: { done: 0, current: 1 },
    pago:                 { done: 1, current: 2 },
    postado:              { done: 2, current: 2 },
    coletado:             { done: 2, current: 3 },
    em_transito:          { done: 2, current: 3 },
    entregue:             { done: 4, current: -1 },
    // Pré-venda sem nada despachado. NÃO é um degrau novo — é a ausência de
    // um: para no "Pagamento aprovado" e não acende nada.
    //
    // Sem isto, `estado='pago'` acendia "Postado" como etapa EM CURSO enquanto
    // a mensagem logo acima dizia que a peça sai daqui a um mês. A escada é o
    // que a cliente olha primeiro, então quem ganhava a discussão era a versão
    // errada. Não afirmar nada é melhor que afirmar o que não está acontecendo.
    prevenda:             { done: 1, current: -1 }
  };

  /* ── Status do ERP Base ───────────────────────────────────────────────────
     Chaveado por status_base_id, NÃO pelo nome. O nome é editável no Base e um
     rename silencioso derrubaria o de-para inteiro sem erro nenhum — a tela
     cairia no texto genérico e ninguém perceberia. O ID é o contrato.

     Catálogo completo: 23 status em base_order_statuses. Os que não estão
     neste mapa NÃO mostram linha nenhuma, de propósito (Em tratamento,
     Etiqueta com erro, Aguardando liberação, Prioridade, Arquivado,
     Quarentena, Pacote com Erro, Pedido Antigo, CEP com erro, Sem estoque):
     é vocabulário operacional que a cliente não pode acionar. Status novo do
     Base cai aqui também — falha fechado, nunca quebra a tela.

     Textos aprovados pelo Brenno em 31/07 (não alterar sem novo aprovado). */
  var BASE_MSG = {
    218975: 'Estamos separando o seu pedido no nosso estoque e cuidando com muito carinho.',
    218976: 'Seu pedido foi separado no nosso estoque, daqui a pouco vai pro faturamento.',
    218977: 'Seu pedido está sendo empacotado.',
    218978: 'Seu pedido foi separado e faturado, estamos só esperando a transportadora pegar aqui no nosso Centro de Distribuição.',
    334018: 'Seu pedido foi separado e faturado, estamos só esperando a transportadora pegar aqui no nosso Centro de Distribuição.',
    218867: 'Seu pedido está pronto para envio.',
    221835: 'Nota fiscal emitida. Seu pedido segue para o envio.',
    218868: 'Transportadora coletou o seu pedido, está a caminho do seu endereço.',
    218871: 'Seu pedido foi entregue com sucesso.',
    259242: 'Seu pedido atrasou. Já estamos em cima — se preferir, fale com a gente.',
    221026: 'Seu pedido está em processo de devolução. Entre em contato conosco em sac@semcostura.com'
  };
  var ID_PREVENDA = 378168;

  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (k === 'class') el.className = attrs[k];
        else if (k === 'html') el.innerHTML = attrs[k];
        else if (k === 'text') el.textContent = attrs[k];
        else el.setAttribute(k, attrs[k]);
      }
    }
    if (children) {
      for (var i = 0; i < children.length; i++) {
        if (children[i]) el.appendChild(children[i]);
      }
    }
    return el;
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long' });
  }

  /* Data SEM hora ("2026-09-01"), vinda das previsões do Base.
     NUNCA usar `new Date(ymd)` aqui: string date-only é parseada como UTC, e
     no Brasil (UTC-3) a data volta um dia — 01/09 aparece como 31/08. O
     `fmtDate` acima recebe timestamp com fuso e não tem esse problema; este
     recebe data pura e por isso quebra na mão. */
  function fmtDataDia(ymd) {
    if (!ymd) return '';
    var m = String(ymd).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? m[3] + '/' + m[2] : '';
  }

  function normalizePedido(v) {
    return String(v || '').replace(/[^0-9]/g, '');
  }

  function mailtoHref(pedido) {
    var num = pedido || '';
    var subject = 'Pedido ' + num;
    var body = 'Olá, preciso de ajuda com o pedido ' + num + '.';
    return 'mailto:' + sacEmail +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);
  }

  function mailtoNoOrder() {
    return 'mailto:' + sacEmail;
  }

  function ctaSac(pedido, label, ghost) {
    return h('a', {
      class: 'rastreio__cta' + (ghost ? ' rastreio__cta--ghost' : ''),
      href: pedido ? mailtoHref(pedido) : mailtoNoOrder()
    }, [document.createTextNode(label || 'Fale com a gente')]);
  }

  function ctaTransportadora(url, label) {
    if (!url) return null;
    return h('a', {
      class: 'rastreio__cta',
      href: url, target: '_blank', rel: 'noopener'
    }, [document.createTextNode(label || 'Acompanhar entrega')]);
  }

  // Bloco por entrega: nome (se houver), código copiável, botão acompanhar.
  function renderEntrega(ent, idx, total, ehPrevenda) {
    var wrap = h('div', { class: 'rastreio__entrega' });
    if (total > 1) {
      wrap.appendChild(h('p', { class: 'rastreio__pedido-num',
        text: 'Entrega ' + (idx + 1) + ' de ' + total }));
    }
    if (ent && ent.transportadora) {
      wrap.appendChild(h('p', { class: 'rastreio__entrega-nome', text: ent.transportadora }));
    }
    if (ent && ent.codigo) {
      var codeRow = h('div', { class: 'rastreio__code-row' });
      codeRow.appendChild(h('code', { class: 'rastreio__code', text: ent.codigo }));
      var copyBtn = h('button', {
        type: 'button', class: 'rastreio__copy',
        'data-rastreio-copy': ent.codigo,
        'aria-label': 'Copiar código de rastreio'
      }, [document.createTextNode('Copiar')]);
      codeRow.appendChild(copyBtn);
      wrap.appendChild(codeRow);
    }
    var cta = ctaTransportadora(ent && ent.url, ehPrevenda ? 'Consultar rastreio' : 'Acompanhar entrega');
    if (cta) {
      var ctaWrap = h('div', { class: 'rastreio__ctas' }, [cta]);
      wrap.appendChild(ctaWrap);
    }
    return wrap;
  }

  function renderEntregas(entregas, ehPrevenda) {
    if (!entregas || !entregas.length) return null;
    var box = h('div', { class: 'rastreio__entregas' });
    for (var i = 0; i < entregas.length; i++) {
      box.appendChild(renderEntrega(entregas[i], i, entregas.length, ehPrevenda));
    }
    return box;
  }

  function renderTimeline(stage) {
    var map = STAGE_MAP[stage] || { done: -1, current: -1 };
    var ul = h('ul', { class: 'rastreio__timeline' });
    for (var i = 0; i < TIMELINE.length; i++) {
      var cls = 'rastreio__step';
      if (i <= map.done) cls += ' is-done';
      if (i === map.current) cls += ' is-current';
      ul.appendChild(h('li', { class: cls }, [
        h('span', { class: 'rastreio__dot', 'aria-hidden': 'true' }),
        h('span', { class: 'rastreio__step-label', text: TIMELINE[i].label })
      ]));
    }
    return ul;
  }

  /* ── Pré-venda ────────────────────────────────────────────────────────────
     Emitir etiqueta/código NÃO significa que o pedido saiu do CD. Enquanto o
     Base mantiver o status Pré-venda, essa é a fonte da verdade para o texto e
     para a timeline; o rastreio continua visível apenas para consulta. */
  function msgPrevenda(data, temEntrega) {
    var desp = fmtDataDia(data && data.despacho_previsto);
    var ent = fmtDataDia(data && data.entrega_prevista);
    if (temEntrega) {
      var avisoCodigo = 'Este é um pedido de <strong>pré-venda</strong>. O código de rastreio já foi emitido, mas o pedido ainda não foi enviado.';
      if (desp && ent) {
        return avisoCodigo + ' Ele será despachado por completo até <strong>' + desp +
          '</strong>, com previsão de entrega até <strong>' + ent + '</strong>.';
      }
      if (desp) {
        return avisoCodigo + ' Ele será despachado por completo até <strong>' + desp + '</strong>.';
      }
      if (ent) {
        return avisoCodigo + ' O envio seguirá a data da pré-venda, com previsão de entrega até <strong>' + ent + '</strong>.';
      }
      return avisoCodigo + ' Assim que a peça chegar ao estoque, despachamos o pedido completo e te avisamos.';
    }
    if (desp && ent) {
      return 'Este é um pedido de <strong>pré-venda</strong>. A peça chega ao nosso estoque e é despachada até <strong>' + desp +
        '</strong>, com previsão de entrega até <strong>' + ent + '</strong>.';
    }
    if (desp) {
      return 'Este é um pedido de <strong>pré-venda</strong>. A peça é despachada até <strong>' + desp +
        '</strong>. Quando sair, você recebe o código de rastreio por aqui.';
    }
    return 'Este é um pedido de <strong>pré-venda</strong>. Assim que a peça chegar ao estoque, despachamos e te avisamos.';
  }

  /* Linha do status Base. Some quando o estado do Shopify é terminal ou
     excepcional: nesses o card já diz tudo, e o Base costuma estar atrasado em
     relação ao transporte. O caso concreto: pedido entregue segundo o Shopify e
     ainda "Despachado" no Base — dizer "está a caminho" de algo que já chegou é
     erro que a cliente percebe na hora. */
  function linhaBase(data, stage) {
    var id = data && data.status_base_id;
    if (!id || id === ID_PREVENDA) return null;
    if (stage === 'cancelado' || stage === 'reembolsado' || stage === 'problema') return null;
    if (stage === 'entregue') return null;
    var msg = BASE_MSG[id];
    return msg ? h('p', { class: 'rastreio__base', text: msg }) : null;
  }

  /* Previsão. Entrega manda; só cai para despacho quando não há entrega
     prevista — são 37 mil pedidos cujo método de entrega não tem transportadora
     cadastrada, e para esses inventar data de chegada seria mentir. Não mostra
     despacho previsto de pedido que já despachou. */
  function linhaPrevisao(data, stage, temEntrega) {
    if (stage === 'entregue' || stage === 'cancelado' || stage === 'reembolsado') return null;
    var ent = fmtDataDia(data && data.entrega_prevista);
    if (ent) {
      return h('p', { class: 'rastreio__previsao', text: 'Previsão de entrega: até ' + ent });
    }
    var desp = fmtDataDia(data && data.despacho_previsto);
    if (desp && !temEntrega) {
      return h('p', { class: 'rastreio__previsao', text: 'Previsão de despacho: até ' + desp });
    }
    return null;
  }

  function cardTimeline(pedidoNum, msgHtml, stage, ctas, entregasNode, extras) {
    var card = h('div', { class: 'rastreio__card' });
    if (pedidoNum) {
      card.appendChild(h('p', { class: 'rastreio__pedido-num', text: 'Pedido #' + pedidoNum }));
    }
    card.appendChild(h('p', { class: 'rastreio__msg', html: msgHtml }));
    if (extras) {
      for (var e = 0; e < extras.length; e++) if (extras[e]) card.appendChild(extras[e]);
    }
    if (entregasNode) card.appendChild(entregasNode);
    if (ctas && ctas.length) {
      var ctaWrap = h('div', { class: 'rastreio__ctas' });
      for (var i = 0; i < ctas.length; i++) if (ctas[i]) ctaWrap.appendChild(ctas[i]);
      if (ctaWrap.childNodes.length) card.appendChild(ctaWrap);
    }
    card.appendChild(renderTimeline(stage));
    return card;
  }

  function cardAlert(pedidoNum, msgHtml, ctas, entregasNode) {
    var card = h('div', { class: 'rastreio__card' });
    if (pedidoNum) {
      card.appendChild(h('p', { class: 'rastreio__pedido-num', text: 'Pedido #' + pedidoNum }));
    }
    card.appendChild(h('div', { class: 'rastreio__alert', html: msgHtml }));
    if (entregasNode) card.appendChild(entregasNode);
    if (ctas && ctas.length) {
      var ctaWrap = h('div', { class: 'rastreio__ctas' });
      for (var i = 0; i < ctas.length; i++) if (ctas[i]) ctaWrap.appendChild(ctas[i]);
      if (ctaWrap.childNodes.length) card.appendChild(ctaWrap);
    }
    return card;
  }

  function cardError(msgText) {
    var card = h('div', { class: 'rastreio__card' });
    card.appendChild(h('p', { class: 'rastreio__msg rastreio__error', text: msgText }));
    return card;
  }

  function buildResult(data, pedidoNum) {
    // Contrato canônico: encontrado=false → não encontrado (mesmo com HTTP 200).
    if (data && data.encontrado === false) {
      return cardAlert('',
        'Não encontramos um pedido com esses dados. Confira o número e o e-mail usado na compra. Se precisar, fale com a gente.',
        [ctaSac('', 'Fale com a gente')]);
    }

    var stage = (data && data.estado) || '';
    var entregas = (data && Array.isArray(data.entregas)) ? data.entregas : [];
    var e0 = entregas[0] || null;

    var dPed  = fmtDate(data && data.data_pedido);
    var dPag  = fmtDate(data && data.data_pagamento);
    var dPost = fmtDate(e0 && e0.postado_em);
    // "postado sem evento" = sem atualizado_em OU igual a postado_em
    var hasEvent = !!(e0 && e0.atualizado_em && e0.atualizado_em !== e0.postado_em);
    var dUltEv = fmtDate(e0 && e0.atualizado_em);

    /* Complementos do Base. Em regra, a linha do tempo continua mandando no
       Shopify, que representa a realidade do transporte. A exceção explícita é
       Pré-venda: etiqueta emitida não prova saída física, então o status Base
       prevalece até o pedido realmente deixar a pré-venda. */
    var ehPrevenda = !!(data && data.status_base_id === ID_PREVENDA);
    var temEntrega = entregas.length > 0;
    var entregasNode = renderEntregas(entregas, ehPrevenda);
    var extras = [];
    var nBase = linhaBase(data, stage);
    if (nBase) extras.push(nBase);
    /* A mensagem de pré-venda já inclui as datas disponíveis. Não repetir a
       previsão abaixo do card, com ou sem código emitido. */
    var previsaoJaNaMensagem = ehPrevenda;
    var nPrev = previsaoJaNaMensagem ? null : linhaPrevisao(data, stage, temEntrega);
    if (nPrev) extras.push(nPrev);

    /* Código/etiqueta emitido pode fazer o Shopify classificar como postado,
       coletado ou em trânsito antes de qualquer saída física. Pré-venda vence
       nesses estados: mantém o código visível, mas não afirma despacho e não
       acende os degraus de transporte. Estados terminais continuam mandando. */
    if (ehPrevenda && (stage === 'pago' || stage === 'postado' ||
        stage === 'coletado' || stage === 'em_transito')) {
      return cardTimeline(pedidoNum, msgPrevenda(data, temEntrega), 'prevenda', [], entregasNode, extras);
    }

    switch (stage) {
      case 'aguardando_pagamento':
        return cardTimeline(pedidoNum,
          'Recebemos seu pedido em <strong>' + (dPed || '—') + '</strong>. Assim que o pagamento for confirmado, ele segue para separação.',
          stage, [], null, extras);

      case 'pago':
        return cardTimeline(pedidoNum,
          'Pagamento aprovado em <strong>' + (dPag || '—') + '</strong>. Estamos preparando o seu pedido para envio.',
          stage, [], null, extras);

      case 'postado':
        if (hasEvent) {
          return cardTimeline(pedidoNum,
            'Postado em <strong>' + (dPost || '—') + '</strong>. Última movimentação em <strong>' + dUltEv + '</strong>.',
            stage, [], entregasNode, extras);
        }
        return cardTimeline(pedidoNum,
          'Postado em <strong>' + (dPost || '—') + '</strong>. A atualização por aqui às vezes demora — no site da transportadora a informação costuma aparecer antes. Clique em Acompanhar para ver a posição mais recente.',
          stage, [], entregasNode, extras);

      case 'coletado':
        return cardTimeline(pedidoNum,
          'Coletado pela transportadora em <strong>' + (dUltEv || dPost || '—') + '</strong>. Em breve entra em trânsito.',
          stage, [], entregasNode, extras);

      case 'em_transito':
        return cardTimeline(pedidoNum,
          'Em trânsito desde <strong>' + (dUltEv || dPost || '—') + '</strong>. Acompanhe pelo link da transportadora.',
          stage, [], entregasNode, extras);

      case 'entregue':
        return cardTimeline(pedidoNum,
          'Entregue em <strong>' + (dUltEv || dPost || '—') + '</strong>. Esperamos que você ame. Se algo não estiver certo, fale com a gente.',
          stage, [ctaSac(pedidoNum, 'Algo não está certo?', true)], entregasNode, extras);

      case 'problema':
        return cardAlert(pedidoNum,
          'A transportadora sinalizou um problema com a entrega. Nossa equipe já foi avisada e vai entrar em contato. Se preferir adiantar, fale com a gente.',
          [ctaSac(pedidoNum, 'Fale com a gente')], entregasNode);

      case 'cancelado':
        return cardAlert(pedidoNum,
          'Este pedido foi cancelado. Se não foi você quem cancelou, fale com a gente.',
          [ctaSac(pedidoNum, 'Fale com a gente')]);

      case 'reembolsado':
        return cardAlert(pedidoNum,
          'O reembolso foi processado. O prazo para aparecer na fatura depende do banco. Em caso de dúvida, fale com a gente.',
          [ctaSac(pedidoNum, 'Fale com a gente')]);

      case 'nao_encontrado':
        return cardAlert('',
          'Não encontramos um pedido com esses dados. Confira o número e o e-mail usado na compra. Se precisar, fale com a gente.',
          [ctaSac('', 'Fale com a gente')]);

      default:
        return cardError('Não conseguimos consultar agora. Tente de novo em alguns segundos.');
    }
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[data-rastreio-submit]');
    var lbl = form.querySelector('[data-rastreio-submit-label]');
    if (btn) btn.disabled = !!busy;
    if (lbl) lbl.textContent = busy ? 'Consultando…' : 'Consultar';
  }

  function showResult(node) {
    var box = root.querySelector('[data-rastreio-result]');
    if (!box) return;
    box.innerHTML = '';
    box.hidden = false;
    box.appendChild(node);
  }

  async function consultar(pedido, email) {
    if (!endpoint) {
      return { estado: 'erro_rede' };
    }
    try {
      // Contrato do backend (Zod estrito): { order: string, email: string }.
      // NÃO renomear para "pedido" — o Zod reprova e devolve {encontrado:false} sempre.
      // CORS: allowlist do CRM cobre apenas semcostura.com e www.semcostura.com.
      // Preview via ?preview_theme_id= funciona; hosts *.shopifypreview.com são
      // bloqueados pelo browser — precisam ser adicionados na allowlist do CRM.
      var res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ order: pedido, email: email })
      });
      if (res.status === 404) return { encontrado: false };
      if (!res.ok) return { estado: 'erro_rede' };
      var data = await res.json();
      if (!data || typeof data !== 'object') return { estado: 'erro_rede' };
      // encontrado=false é o sinal canônico; não mexe em estado nesse caso.
      if (data.encontrado !== false && !data.estado) data.estado = 'nao_encontrado';
      return data;
    } catch (_e) {
      return { estado: 'erro_rede' };
    }
  }

  // Listener delegado no container estável (Regra #5).
  root.addEventListener('submit', function (ev) {
    var form = ev.target && ev.target.closest && ev.target.closest('[data-rastreio-form]');
    if (!form) return;
    ev.preventDefault();

    var pedidoRaw = (form.querySelector('[name="pedido"]') || {}).value || '';
    var email = ((form.querySelector('[name="email"]') || {}).value || '').trim();
    var pedido = normalizePedido(pedidoRaw);

    if (!pedido || !email) {
      showResult(cardError('Preencha o número do pedido e o e-mail da compra.'));
      return;
    }

    setBusy(form, true);
    consultar(pedido, email).then(function (data) {
      setBusy(form, false);
      showResult(buildResult(data, pedido));
    });
  });

  // Copiar código de rastreio — delegado no container estável.
  root.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('[data-rastreio-copy]');
    if (!btn) return;
    ev.preventDefault();
    var code = btn.getAttribute('data-rastreio-copy') || '';
    var done = function () {
      var original = btn.textContent;
      btn.textContent = 'Copiado';
      btn.classList.add('is-copied');
      setTimeout(function () {
        btn.textContent = original;
        btn.classList.remove('is-copied');
      }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      try {
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', '');
        ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
      } catch (_e) {}
      done();
    }
  });
})();
